import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { decodeEntities } from '@wordpress/html-entities';
import { Fragment } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
/**
 * Internal dependencies
 */

import { computeSuggestionMatch } from './utils';
import Flag from '../../flag'; // Cache countries to avoid repeated requests.

var allCountries = null;
/**
 * A country completer.
 * See https://github.com/WordPress/gutenberg/tree/master/packages/components/src/autocomplete#the-completer-interface
 *
 * @type {Completer}
 */

export default {
  name: 'countries',
  className: 'woocommerce-search__country-result',
  isDebounced: true,
  options: function options() {
    // Returned cached countries if we've already received them.
    if (allCountries) {
      return Promise.resolve(allCountries);
    } // Make the request for country data.


    return apiFetch({
      path: '/wc-analytics/data/countries'
    }).then(function (result) {
      // Cache the response.
      allCountries = result;
      return allCountries;
    });
  },
  getOptionIdentifier: function getOptionIdentifier(country) {
    return country.code;
  },
  getSearchExpression: function getSearchExpression(query) {
    return '^' + query;
  },
  getOptionKeywords: function getOptionKeywords(country) {
    return [country.code, decodeEntities(country.name)];
  },
  getOptionLabel: function getOptionLabel(country, query) {
    var name = decodeEntities(country.name);
    var match = computeSuggestionMatch(name, query) || {};
    return createElement(Fragment, null, createElement(Flag, {
      key: "thumbnail",
      className: "woocommerce-search__result-thumbnail",
      code: country.code,
      size: 18,
      hideFromScreenReader: true
    }), createElement("span", {
      key: "name",
      className: "woocommerce-search__result-name",
      "aria-label": name
    }, query ? createElement(Fragment, null, match.suggestionBeforeMatch, createElement("strong", {
      className: "components-form-token-field__suggestion-match"
    }, match.suggestionMatch), match.suggestionAfterMatch) : name));
  },
  // This is slightly different than gutenberg/Autocomplete, we don't support different methods
  // of replace/insertion, so we can just return the value.
  getOptionCompletion: function getOptionCompletion(country) {
    var value = {
      key: country.code,
      label: decodeEntities(country.name)
    };
    return value;
  }
};
//# sourceMappingURL=countries.js.map